/**
 * User: nir
 * Date: 17/11/2016
 * Time: 6:53
 */

if (window.jQuery) {
    window.jQuery(function ($) {
        var logMsg = '1st Paragraph Positioning: ';

        if ($('section[data-type="article-content"]').length <= 0) return;

        function log() {
            if (TCT && TCT.debug) {
                var args = Array.prototype.slice.call(arguments, 0);
                if (args && args.length) args[0] = logMsg + args[0];
                TCT.debug.apply(this, args);
            }
        }

        function bail(reason) {
            log('Bailing because ' + reason);
        }

        // make sure slot is found on page
        var slot = $('.after-first-paragraph');

        // make sure slot is not already placed
        if (slot && slot.is('.placed')) return bail('slot is already placed');

        // make sure content is found on page
        var content = $('section.content[data-type="article-content"]');
        if (!content || !content.length) return bail('article content was not found on page');

        function findPositionInContent() {
            return content.find('>:not(:empty)').eq(0);
        }

        // find the position in the content after which the ad slot will be placed
        var position = findPositionInContent();

        if (!position || !position.length) return bail('could not find first paragraph in content');

        // mark the first paragraph with a suitable class name
        position.toggleClass('first-paragraph', true);

        // move the ad slot to its new place
        if (slot) slot.remove().insertAfter(position).toggleClass('placed', true);

        log('paragraph positioned.');
    });
}